ko.bindingHandlers["updateNotifier"] =
   update: (element, valueAccessor) ->
      accessor = ko.unwrap(valueAccessor())
      # # To set dependency.
      trigger = ko.unwrap(accessor.trigger)
      notifier = accessor.notifier
      notifier()